"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// eslint-disable-next-line @typescript-eslint/no-var-requires
var typePolicies = require('@shared-ui/apollo-type-policies').typePolicies;
module.exports = __assign({}, typePolicies);